<template>
  
  <div>

    <b-breadcrumb class="d-none d-lg-flex">
      <b-breadcrumb-item>Administratie</b-breadcrumb-item>
      <b-breadcrumb-item to="..">Contracten</b-breadcrumb-item>
      <b-breadcrumb-item active>Contract {{contract.name}}</b-breadcrumb-item>
    </b-breadcrumb>

    <div class="d-flex align-items-center justify-content-between">
      <h2 class="d-none d-lg-block">Contract
        {{contract.name}} <small class="text-muted">{{contract.customer.name}}</small></h2>
      <div>
        <b-btn :to="`/main/admin/contracts/createInvoice/${id}`" variant="primary"><span class="mdi mdi-rocket"/> Factuur maken</b-btn>
        <b-btn class="ml-2"  variant="primary" :to="`/main/admin/contracts/edit/${id}`"><span class="mdi mdi-pencil" /> Bewerken</b-btn>
      </div>
    </div>

    <h3>Status</h3>

    <p>Gestart op {{contract.start|format_moment('YYYY-MM-DD')}}</p>
    <p v-if="contract.terminated">Beëindigd op {{contract.terminatedOn|format_moment('YYYY-MM-DD')}}</p>
    <p v-else>Actief</p>

    <h3>Printers in contract</h3>

    <b-table-simple small>
      <thead>
      <tr>
        <th>Merk</th>
        <th>Model</th>
        <th>Serienr</th>
        <th>Merk op contract</th>
        <th>Naam op contract</th>
        <th>Locatie op contract</th>
        <th>Laatste teller update</th>
        <th>Verbonden via</th>
      </tr>
      </thead>
      <b-tbody>
      <b-tr v-for="({brand, location, name, printer}) in contract.contractPrinters.nodes" :key="printer.id">
        <td>{{printer.model.brand.name}}</td>
        <td>{{printer.model.name}}</td>
        <td><b-link :to="`/main/admin/printers/view/${printer.id}`">{{printer.serial}}</b-link></td>
        <td>{{brand}}</td>
        <td>{{name}}</td>
        <td>{{location}}</td>
        <td>
          <span v-if="printer.lasts.nodes.length === 0"></span>
          <span v-else>{{printer.lasts.nodes[0].tsms|format_duration($store.state.now)}}</span>
        </td>
        <td>
          <template v-if="printer.device">
            <template v-if="printer.device.status === 'ONLINE'">
              <span class="mdi mdi-network-outline text-success"> Online</span>
            </template>
            <template v-else>
              <span class="mdi mdi-network-off-outline text-danger"> Offline</span>
            </template>
            {{printer.device.displayName}} <small>{{printer.device.serial}}</small>
          </template>
          <template v-else>Niet verbonden</template>
        </td>
      </b-tr>
      </b-tbody>
    </b-table-simple>

    <h3>Tupels</h3>
    <b-table-simple small>
      <thead>
      <tr>
        <th>Toestellen</th>
        <th>Tellergroep weergavenaam</th>
        <th class="text-right">Forfait aantal prints/trimester</th>
        <th class="text-right">Forfait prijs</th>
        <th class="text-right">Supplementaire afdrukken</th>
        <th>Tuple weergavenaam</th>

      </tr>
      </thead>
      <tbody>
      <tr v-for="tuple in contract.tuples.nodes" :key="tuple.id">
        <td data-bind="foreach: printers">
          <template v-for="({contractPrinter}) in tuple.tupleContractPrinters.nodes">
            <p :key="`t_${contractPrinter.id}`" class="m-0">{{contractPrinter.brand}} {{contractPrinter.name}} {{contractPrinter.printer.serial}}</p>
          </template>
        </td>
        <td>{{tuple.cgroup.displayName}}</td>
        <td class="text-right">{{tuple.forfaitNumPrints}}</td>
        <td class="text-right">{{tuple.forfaitPrice|format_money}}</td>
        <td class="text-right">{{tuple.supplPricePerUnit|format_money}}</td>
        <td>{{tuple.displayName}}</td>

      </tr>
      </tbody>
    </b-table-simple>

    <h3>Facturen</h3>

    <table-wrap :query="$options.invoices" :variables="invoiceVariables" list-path="contractById.invoices" :state.sync="invoicesState"
      :fields="$options.invoiceFields" small>
      <template #cell(created)="{item}">
        {{item.created|format_moment('YYYY-MM-DD')}}
      </template>
      <template #cell(quarter)="{item}">
        Q{{item.quarter}} {{item.year}}
      </template>
      <template #cell(actions)="{item}">
        <b-btn variant="danger" size="sm" @click="objToDelete = item"><span class="mdi mdi-trash-can-outline"/> Verwijderen</b-btn>
        <b-btn variant="primary" size="sm" class="ml-1" :href="`${item.sourceUrl}`" target="_blank">
          <span class="mdi mdi-open-in-new"/> Bekijken
        </b-btn>
      </template>
    </table-wrap>

<!--    <b-table-simple class="table table-sm small invoice-list">
      <thead>
      <tr>
        <th>Acties</th>
        <th>Factuurdatum</th>
        <th>Afrekening van kwartaal</th>
        <th>Titel</th>
      </tr>
      </thead>
      <tbody data-bind="foreach: invoices">
      <tr>
        <td>
          <button class="btn btn-xs btn-outline-danger" data-bind="click: $parent.btnDeleteInvoice">
            <i class="fa fa-fw fa-trash"></i> Verwijderen
          </button>
          <a target="_blank" data-bind="attr: { href: viewUrl }" class="btn btn-outline-primary btn-xs">
            <i class="fa fa-fw fa-external-link"></i>
            <span data-bind="visible: isCreditnote">Creditnota bekijken</span>
            <span data-bind="visible: !isCreditnote">Factuur bekijken</span>
          </a>
        </td>
        <td><span data-bind="text: moment(creation).format('DD/MM/YYYY')"></span></td>
        <td>Q<span data-bind="text: quarter"></span> <span data-bind="text: year"></span></td>
        <td><span data-bind="text: title"></span></td>
      </tr>
      </tbody>
    </b-table-simple>-->

    <div class="modal fade" role="dialog" id="delete-invoice-modal">
      <div class="modal-dialog" data-bind="with: deleteInvoiceModal">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal">&times;</button>
            <h4 class="modal-title">Ben je zeker?</h4>
          </div>
          <div class="modal-body" data-bind="with: objToDelete">
            <p>Alle relevante data aan dit object zal ook gewist worden. Deze operatie kan niet ongedaan gemaakt worden.
              Ben je zeker dat je het geselecteerde object wil verwijderen?</p>
            <p>Dit verwijdert niet de factuur uit Teamleader.</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-danger" data-dismiss="modal" data-bind="click: btnConfirm">Ja</button>
            <button type="button" class="btn btn-success" data-dismiss="modal">Nee</button>
          </div>
        </div>
      </div>
    </div>

    <b-modal centered title="Factuur verwijderen" title-class="font-weight-bold" v-model="showDelete" lazy>
      <template #default v-if="objToDelete">
        <p>Ben je zeker dat je deze factuur wil wil verwijderen?</p>
        <p>De tellerstanden van deze factuur zullen ook verwijderd worden.</p>
        <p>Dit verwijdert niet de factuur uit Teamleader.</p>
      </template>
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-btn variant="secondary" @click="cancel">Annuleren</b-btn>
        <busy-btn variant="danger" @click="okDelete(ok)" :busy="deleteBusy">Verwijderen</busy-btn>
      </template>
    </b-modal>

  </div>
  
</template>

<script>

import TableWrap from '@/components/TableWrap';
import vuex_computed from '@/lib/vuex_computed';
import {M_SET_CONTRACT_INVOICES_VIEW, M_SET_SUBTITLE} from '@/lib/constants';
import actionField from '@/lib/actionField';
import delFromModal from '@/lib/delFromModal';
import BusyBtn from '@/components/BusyBtn';
import delModalShow from '@/lib/delModalShow';

export default
{
    apollo:
    {
        $subscribe:
        {
            contract:
            {
                query: require('../../graphql/viewContract.sub.gql'),
                variables() { return { id: this.id } },
                result({data})
                {
                    this.contract = data.contractById;
                    this.$store.commit(M_SET_SUBTITLE, this.contract.name);
                }
            }
        }
    },
    components: { BusyBtn, TableWrap },
    computed:
    {
        invoicesState: vuex_computed('contractInvoicesView', M_SET_CONTRACT_INVOICES_VIEW),
        showDelete: delModalShow()
    },
    data()
    {
        return {
            contract: { customer: {}, contractPrinters: { nodes: [] }, tuples: { nodes: [] } },
            deleteBusy: false,
            invoiceVariables: { id : this.id },
            objToDelete: null
        }
    },
    methods:
    {
        okDelete: delFromModal(require('../../graphql/mutation/delete_invoice.gql'))
    },
    props: ['id'],
    breadcrumb:
    [
        { text: 'Administratie' },
        { text: 'Contracten', to: '/admin/contracts' },
        { text: 'Contract x'}
    ],
    invoices: require('../../graphql/live/contract_invoices.gql'),
    invoiceFields:
    [
        {
            key: 'created',
            label: 'Opgemaakt'
        },
        {
            key: 'quarter',
            label: 'Afrekening van kwartaal'
        },
        {
            key: 'title',
            label: 'Titel'
        },
        actionField
    ]
}
</script>

<style>
</style>